<template>
  <el-dialog
    v-el-drag-dialog
    :title="$t('CargoMsg.Cargo_AbnormalComment')"
    :close-on-click-modal="false"
    :visible.sync="innerVisible"
    width="430px"
    @close="cancel"
  >
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form :inline="true" label-width="70px" label-position="left" @submit.native.prevent>
        <div style="margin-top: 10px;">
          <el-form-item :label="$t('CargoMsg.Cargo_MarkAbnormal')">
            <el-checkbox v-model="abnormal" @change="abnormalCheckHandler" />
          </el-form-item>
          <el-form-item v-if="abnormal" :label="$t('CargoMsg.Cargo_AbnormalState')" required>
            <el-select v-model="abnormalState" style="width:295px;">
              <el-option
                v-for="item in SystemConstants.OCABNORMAL_STATE"
                :key="item.code"
                :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_AbnormalRemark')">
            <el-input v-model="abnormalRemark" style="width:295px;" :maxlength="200" />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="primary" size="mini" @click="confirm">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button size="mini" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { abnormal } from '@/api/clearing/ocPayment'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'MarkAbnormalDialog',
  props: {
    visible: { type: Boolean, required: true },
    ocPayment: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      abnormal: false,
      abnormalState: 0,
      abnormalRemark: '',
      loading: null
    }
  },
  computed: {
    SystemConstants() {
      return SystemConstants
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.abnormal = this.ocPayment.abnormal
      this.abnormalState = this.ocPayment.abnormalState
      this.abnormalRemark = this.ocPayment.abnormalRemark
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    abnormalCheckHandler() {
      if (!this.abnormal) {
        this.abnormalState = 0
      } else {
        if (this.ocPayment.abnormalState === 0) {
          this.abnormalState = 1
        } else {
          this.abnormalState = this.ocPayment.abnormalState
        }
      }
    },
    confirm() {
      this.$confirm(this.$t('CargoMsg.Cargo_ConfirmOrNot') + '?', this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        this.ocPayment.abnormal = this.abnormal
        this.ocPayment.abnormalState = this.abnormalState
        this.ocPayment.abnormalRemark = this.abnormalRemark
        abnormal([this.ocPayment]).then(res => {
          this.$emit('success', res.data)
          this.innerVisible = false
          this.$message.success(this.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
        }).finally(() => {
          if (this.loading) {
            this.loading.close()
          }
        })
      })
    },
    cancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss">
</style>
